export { DefaultActiveUserState } from "@bitwarden/state";
